module.exports = __webpack_public_path__ + "img/stay-home.f0218a61.svg";